import React, { PureComponent } from 'react';
import { string } from 'prop-types';
import classnames from 'classnames';
import PromptMessage from '../information/PromptMessage';
import OrderViewMode from './components/OrderViewMode';

class OrderDetailContent extends PureComponent {
   static propTypes = {
     orderDescription: string,
     className: string,
   };

   render() {
     const {
       orderDescription,
       className,
       ...rest
     } = this.props;

     const classes = classnames(
       {
         'order-detail__content': true,
       },
       className,
     );

     return (
       <div className={classes}>
         <PromptMessage message={orderDescription} />
         <OrderViewMode {...rest}/>
       </div>
     );
   }
}

export default OrderDetailContent;
